<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_street"
            class="form-control-label">{{ $t('views.userdata.form.street') }}:</label>
          <input
            id="userdata_street"
            v-model="item.street"
            :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('street', $event.target.value)">
          <div
            v-if="isInvalid('street')"
            class="invalid-feedback">{{ violations.street }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_city"
            class="form-control-label">{{ $t('views.userdata.form.city') }}:</label>
          <input
            id="userdata_city"
            v-model="item.city"
            :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('city', $event.target.value)">
          <div
            v-if="isInvalid('city')"
            class="invalid-feedback">{{ violations.city }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_postcode"
            class="form-control-label">{{ $t('views.userdata.form.postcode') }}:</label>
          <input
            id="userdata_postcode"
            v-model="item.postcode"
            :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('postcode', $event.target.value)">
          <div
            v-if="isInvalid('postcode')"
            class="invalid-feedback">{{ violations.postcode }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_province"
            class="form-control-label">{{ $t('views.userdata.form.province') }}:</label>
          <input
            id="userdata_province"
            v-model="item.province"
            :class="['form-control', isInvalid('province') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('province', $event.target.value)">
          <div
            v-if="isInvalid('province')"
            class="invalid-feedback">{{ violations.province }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_country"
            class="form-control-label">{{ $t('views.userdata.form.country') }}:</label>
          <input
            id="userdata_country"
            v-model="item.country"
            :class="['form-control', isInvalid('country') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('country', $event.target.value)">
          <div
            v-if="isInvalid('country')"
            class="invalid-feedback">{{ violations.country }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label>{{$t('views.userdata.form.addressType')}}: </label>
          <model-select name="address_type_options" :options="addressTypeOptions" v-model="item.addressType">
          </model-select>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import { mapGetters } from 'vuex'

export default {
  components: {
    ModelSelect
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
    }
  },

  created () {
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
    ...mapGetters({
      addressTypeOptions: 'userdataaddress/list/addressTypeOptions'
    })
  },

  methods: {
    closeModal () {
      if (this.item['@id']) {
        this.$store.state.modals.userdataaddress.update.close = 1
      } else {
        this.$store.state.modals.userdataaddress.create.close = 1
      }
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
